<script setup lang="ts">
import type { Component } from 'vue';

withDefaults(
  defineProps<{
    active: boolean;
    disabled?: boolean;
    as?: string | Component;
  }>(),
  {
    as: 'button',
  }
);
</script>

<template>
  <component
    :is="as"
    class="Connx-btn--tab"
    :class="{
      'Connx-btn--tab--active': active,
      'Connx-btn--disabled': disabled,
    }"
    role="tab"
    :type="as === 'button' ? 'button' : undefined"
    v-bind="$attrs"
  >
    <slot></slot>
  </component>
</template>
